import { useMemo } from 'react'
import { IFilterOptionsSource } from '@forwardflow/features/campaign-filter/context/FilterOptions.context'
import { TLeadType as TFilterField } from '@forwardflow/features/campaign-filter/interfaces'
import { LeadService } from '@forwardflow/services/LeadService'
import {
   filterVocabularyNow,
   filterVocabularyReady,
} from '@forwardflow/features/campaign-flow/utils/describe'

/**
 * The dashboard's filter rows fetch their values from Follow Up Boss on every
 * keystroke (about a second each on production). The Who step already loads
 * the organization's sources, stages, tags and ponds once when it opens, so
 * its rows answer from that list and search it in memory.
 */
const useVocabularyOptions = (field: TFilterField, search?: string) => {
   const ready = filterVocabularyReady()
   const q = (search || '').trim().toLowerCase()
   const options = useMemo(() => {
      if (!ready || field === 'inquired_property') return []
      const all =
         filterVocabularyNow()[
            field as keyof ReturnType<typeof filterVocabularyNow>
         ] ?? []
      return q ? all.filter((o) => o.label.toLowerCase().includes(q)) : all
   }, [field, q, ready])
   return {
      options,
      isLoading: !ready && field !== 'inquired_property',
      error: null,
      loadMore: () => undefined,
      hasMore: false,
   }
}

const VOCABULARY_SOURCE: IFilterOptionsSource = {
   useOptions: useVocabularyOptions,
   searchProperties: (q, limit) =>
      LeadService.searchInquiredProperties(q, limit),
}

/** The filter rows' values: the list the Who step loaded, searched in memory. */
export const useFilterOptionsSource = (): IFilterOptionsSource | null =>
   VOCABULARY_SOURCE
